import { clsx } from 'clsx'

import { I18nShape, useStaticIntl } from '@tribeplatform/react-components/i18n'
import { Checkbox } from '@tribeplatform/react-ui-kit/Checkbox'

import { useCustomizer, useCustomizerNavigation } from '../hooks/index.js'
import { CustomizerActionType } from '../types.js'

const optionsFactory: (options: {
  headerDisabled: boolean
  sidebar1Disabled: boolean
}) => (intl: I18nShape) => Array<{
  key: 'header' | 'sidebar1'
  label: string
  disabled: boolean
}> =
  ({ headerDisabled, sidebar1Disabled }) =>
  ({ $t }) => [
    {
      key: 'header',
      label: $t({ defaultMessage: 'Header', id: 'Generics.Header' }),
      disabled: headerDisabled,
    },
    {
      key: 'sidebar1',
      label: $t({ defaultMessage: 'Sidebar', id: 'Generics.Sidebar' }),
      disabled: sidebar1Disabled,
    },
  ]

export const DisableNavigationPicker = () => {
  const {
    navigationSlates: { headerDisabled = false, sidebar1Disabled = false },
  } = useCustomizerNavigation()
  const { dispatch } = useCustomizer()

  const options = useStaticIntl(
    optionsFactory({ headerDisabled, sidebar1Disabled }),
  )

  return (
    <div className="grid grid-cols-2 gap-2">
      {options.map(option => (
        <button
          className={clsx(
            'flex flex-row col-span-1 py-1 px-2 hover:bg-surface-hovered border border-1 rounded-base items-center',
            !option.disabled
              ? 'text-content-subdued border-line'
              : 'text-content-subdued border-line-subdued',
          )}
          key={option.key}
          type="button"
          onClick={() => {
            dispatch({
              type: CustomizerActionType.NEW_UPDATE,
              payload: {
                key: option.key,
                disabled: !option.disabled,
              },
            })
          }}
        >
          <Checkbox checked={!option.disabled} onChange={e => e} />
          <span>{option.label}</span>
        </button>
      ))}
    </div>
  )
}
